import React from 'react'
import { ImageNotFoundWrapper, ImageNotFound } from './styles'
import { Navbar } from '../NavBar'
import { AppWrapper, MainContent } from '../../GlobalStyles/AppStyles'
import { SideBar } from '../SideBar'

export const NotFound = () => {
  return (
    <>
      <Navbar />
      <AppWrapper id='detail'>
        <SideBar />
        <MainContent>
          <ImageNotFoundWrapper>
            <ImageNotFound src={process.env.PUBLIC_URL + '/NotFound.png'} alt='NotFound' />
          </ImageNotFoundWrapper>
        </MainContent>
      </AppWrapper>
    </>
  )
}
